export default __webpack_public_path__ + "static/media/document-pdf.bca4413a.svg";